import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {catchError} from 'rxjs/operators';
import {HttpRequestErrorHandler} from '@rbaip/ui-component';
import {Observable} from 'rxjs';
import {ItemSummaryAssetAuditService} from './item-summary-asset-audit.service';
import {appConfig} from '../../app.config';

@Injectable({
  providedIn: 'root'
})
export class ItemSummaryAssetAuditImplService extends  ItemSummaryAssetAuditService {

  private readonly assetAuditInformationUrl = '/api/asset-audit/:assetId/information';

  constructor(private http: HttpClient) {
    super();
  }

  public getAssetAuditInformation(assetId: number): Observable<any> {
    let url = this.assetAuditInformationUrl;
    url = url.replace(':assetId', assetId.toString());
    return this.http.get(url, appConfig.httpOptions)
      .pipe(
        catchError(HttpRequestErrorHandler.handleError('getAssetAuditInformation', {}))
      );
  }
}
